import { load } from '@fingerprintjs/fingerprintjs-pro'
import { environmentConfig } from '@/config/enviromentConfig'

let agentPromise = null

function getAgent() {
    if (!agentPromise) {
        agentPromise = load({
            apiKey: environmentConfig.fingerprintPublicKey,
            region: environmentConfig.fingerprintRegion,
        })
    }

    return agentPromise
}

const IDENTIFY_TIMEOUT_MS = 2000

export async function getFingerprintRequestId() {
    if (!environmentConfig.fingerprintPublicKey) return null

    try {
        return await Promise.race([
            identify(),
            new Promise((resolve) => setTimeout(() => resolve(null), IDENTIFY_TIMEOUT_MS)),
        ])
    } catch {
        return null
    }
}

async function identify() {
    const agent = await getAgent()
    const result = await agent.get()

    return result.requestId ?? null
}
